import MiniSearch from 'minisearch';
import type { SpotlightCatalogItem, SpotlightMenuItem } from '../types';

function squeezeLetters(value: string): string {
  let out = '';
  let prev = '';
  for (const ch of value.toLowerCase()) {
    if (ch === prev) continue;
    out += ch;
    prev = ch;
  }
  return out;
}

function catalogToMenu(item: SpotlightCatalogItem): SpotlightMenuItem {
  return {
    id: item.id,
    name: item.name,
    description: item.description,
    url: item.url,
    full_path: item.url,
    type: item.type,
    application_id: item.application_key,
    application_name: item.application_name,
    access_level: '',
    is_enable: item.is_enabled,
    score: 1,
  };
}

export class CatalogSearchIndex {
  private index = new MiniSearch<SpotlightCatalogItem>({
    fields: ['name', 'description', 'application_name', 'keywordsText'],
    storeFields: [
      'id',
      'external_id',
      'name',
      'description',
      'url',
      'type',
      'application_key',
      'application_name',
      'keywords',
      'is_enabled',
    ],
    searchOptions: {
      prefix: true,
      fuzzy: 0.2,
      boost: { name: 2, application_name: 1.5 },
    },
  });

  load(items: SpotlightCatalogItem[]) {
    const prepared = items.map((item) => ({
      ...item,
      keywordsText: (item.keywords ?? []).join(' '),
    }));
    this.index.removeAll();
    this.index.addAll(prepared);
  }

  search(query: string, limit = 10): SpotlightMenuItem[] {
    const trimmed = query.trim();
    if (!trimmed) return [];

    const normalized = squeezeLetters(trimmed);
    let hits = this.index.search(normalized, { fuzzy: 1 });
    if (!hits.length && normalized !== trimmed.toLowerCase()) {
      hits = this.index.search(trimmed.toLowerCase(), { fuzzy: 1 });
    }

    return hits.slice(0, limit).map((hit) =>
      catalogToMenu({
        id: String(hit.id),
        external_id: String(hit.external_id ?? hit.id),
        name: String(hit.name ?? ''),
        description: String(hit.description ?? ''),
        url: String(hit.url ?? ''),
        type: String(hit.type ?? 'menu'),
        application_key: String(hit.application_key ?? ''),
        application_name: String(hit.application_name ?? hit.application_key ?? ''),
        keywords: (hit.keywords as string[] | undefined) ?? [],
        is_enabled: Boolean(hit.is_enabled ?? true),
      }),
    );
  }
}
